import type {
    List as FullList,
    Product,
    RetailItem,
} from 'adapters/list/graphqlTypes';

export default (languageCode: string) => /* GraphQL */ `
fragment ListFields on List {
  updated
  quantity
  name
  isSelected
  listId
  retail(languageCode: "${languageCode}") {
    items {
      itemNo
      quantity
      product {
        globalName
      }
    }
  }
}`;

// This type represents the object above
export type List = Pick<
    FullList,
    'updated' | 'quantity' | 'name' | 'isSelected' | 'listId'
> & {
    retail: {
        items: Array<
            Pick<RetailItem, 'itemNo' | 'quantity'> & {
                product: Pick<Product, 'globalName'>;
            }
        >;
    };
};
